import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Flexer, Icon } from '@ontruck/orc';

import TableCellIdStyled from './styled';

const t = {
  new_order: 'New order',
};

class TableCellId extends PureComponent {
  render() {
    const { id } = this.props;

    return (
      <TableCellIdStyled>
        <Flexer.Parent alignItems="center">
          <span>{id ? `S ${id}` : t.new_order}</span>
          <Flexer.Parent alignItems="center">
            <Icon glyph="repeat" size="2.4rem" color="greyWolf" />
          </Flexer.Parent>
        </Flexer.Parent>
      </TableCellIdStyled>
    );
  }
}

TableCellId.propTypes = {
  id: PropTypes.string,
};

TableCellId.defaultProps = {
  id: null,
};

export default TableCellId;
